
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { handleError } from '../../../../api';
import { WindowType } from '../../../../util';
import { Board, CardAttributeDefinition, CardAttributeDefinitionType } from '../../../backend/backendapi';
import { KanbanState } from '../../kanban.model';
import EditModal from './EditModal';

declare var window: WindowType;

@Component({
  name: 'AttributeDefinitionsModal',
  components: {
    EditModal,
  },
})
export default class AttributeDefinitionsModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;
  @Prop({ required: true })
  readonly board!: Board;

  get canEdit(): boolean {
    return window.application.permissions.kanban.cardAttributeDefinitionEdit;
  }

  public open(): void {
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  add(): void {
    const attribute = new CardAttributeDefinition({
      id: 0,
      name: '',
      boardId: this.board.id!,
      type: CardAttributeDefinitionType.String,
      order: (this.board.attributeDefinitions ?? []).map(e => e.order).reduce((l, r) => Math.max(l, r), -1) + 1,
    });
    (this.$refs.editModal as EditModal).open(this.board, attribute);
  }

  edit(attr: CardAttributeDefinition): void {
    if (!this.canEdit) {
      return;
    }
    (this.$refs.editModal as EditModal).open(this.board, attr);
  }

  del(attr: CardAttributeDefinition): void {
    if (!this.canEdit) {
      return;
    }
    if (confirm(this.$t('kanbanConfirmDelete') + '\n- ' + attr.name)) {
      this.state.attributeDefinitionAPI.delete(attr.id)
          .then(_ => {
            if (!this.board.attributeDefinitions) {
              this.board.attributeDefinitions = [];
            }
            let index = this.board.attributeDefinitions!.findIndex(e => e.id === attr.id);
            if (index >= 0) {
              this.board.attributeDefinitions!.splice(index, 1);
            }
            this.$toasted.info(this.$t('txtDeleted').toString());
          })
          .catch(e => handleError(this.$toasted, this.$i18n, e));
    }
  }
}
